<div class="checkpoint-form-header">
  <div class="cf-header-row">
    <app-icon name="map-pin-check-inside" [size]="16" />
    <span>{{ checkpointName }}</span>
  </div>
  @if (formName) {
  <div class="cf-header-row">
    <app-icon name="clipboard-pen-line" [size]="16" />
    <span>{{ formName }}</span>
  </div>
  }
  @if (serialNumber) {
  <div class="cf-header-row">
    <app-icon name="hash" [size]="16" />
    <span class="cf-serial-badge">{{ serialNumber }}</span>
  </div>
  }
</div>